import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  signal,
  Signal
} from '@angular/core';
import { InfoBulleComponent } from '../../info-bulle/info-bulle.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { Country } from '../../../core/api/models/country';
import { SnackBarService } from '../../../shared/services/snack-bar.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'acs-cover-zone-option-section',
  imports: [
    InfoBulleComponent,
    TranslatePipe,
    MatFormField,
    MatSuffix,
    MatAutocomplete,
    MatRadioGroup,
    MatRadioButton,
    MatAutocompleteTrigger,
    MatInput,
    MatOption,
    MatIcon,
    ReactiveFormsModule,
    MatIconButton
  ],
  templateUrl: './cover-zone-option-section.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CoverZoneOptionSectionComponent {
  readonly #snackBarService: SnackBarService = inject(SnackBarService);

  @Input({ required: true }) expatAdditionalCountryFC!: FormControl;
  @Input({ required: true }) expatCoverNationalityCountryFC!: FormControl;
  @Input({ required: true }) coverageZone: string | undefined;
  @Input({ required: true }) addCountries!: Signal<Country[] | undefined>;
  @Input({ required: true }) addCountriesOptions!: Signal<Country[] | undefined>;
  @Input({ required: true }) alreadyCovered!:
    | 'Oui'
    | 'Non'
    | 'non_applicable'
    | undefined;

  public clearCountry(event: Event, trigger: MatAutocompleteTrigger): void {
    // Le clic ne doit pas atteindre le mat-form-field : sinon l’input reprend le
    // focus et le panneau d’autocomplétion se réouvre aussitôt.
    event.stopPropagation();
    this.expatAdditionalCountryFC.reset();
    trigger.closePanel();
    // Le toast d’erreur portait sur le pays effacé : il n’a plus lieu d’être.
    this.#snackBarService.dismiss();
  }

  public isCountrySelected(): boolean {
    const value = this.expatAdditionalCountryFC?.value;
    if (!value) {
      return false;
    }
    return !!this.addCountries()?.some((country) => country.alpha3 === value);
  }

  displayAddCountry = (countryCode: string): string => {
    if (!countryCode) return '';

    return (
      this.addCountries()!.find((c) => c.alpha3 === countryCode)?.label ?? ''
    );
  };
}
